import { render, staticRenderFns } from "./rejectDialog.vue?vue&type=template&id=529a40e1&scoped=true"
import script from "./rejectDialog.vue?vue&type=script&lang=js"
export * from "./rejectDialog.vue?vue&type=script&lang=js"
import style0 from "./rejectDialog.vue?vue&type=style&index=0&id=529a40e1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529a40e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('529a40e1')) {
      api.createRecord('529a40e1', component.options)
    } else {
      api.reload('529a40e1', component.options)
    }
    module.hot.accept("./rejectDialog.vue?vue&type=template&id=529a40e1&scoped=true", function () {
      api.rerender('529a40e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/approve/components/rejectDialog.vue"
export default component.exports